/* global angular */

'use strict';

define('app',[
        'TVGCommon',
        'DepositGTM',
        'Configuration',
        'Content',
        'AppCore',
        'Layout',
        'RaceInfo',
        'Races',
        'Security',
        'UserProfile',
        'Utilities',
        'BetService',
        'BetSlipWindow',
        'uibootstrap',
        'uibootstraptpls',
        'Poller',
        'angularCookies',
        'Deposit',
        'Features',
        'ngMd5',
        'TrackSelector',
        'tvgTemplates',
        'BetslipMainMod',
        'FavoriteTracks',
        'Preferences',
        'Graph',
        'GTMDesktopMod'
    ], function (TVGCommon, DepositGTM) {

        angular.module('TVG', [
            'ngRoute',
            'ngCookies',
            'ipCookie',
            'ab-base64',
            'ngSanitize',
            'ngMd5',
            'ngAnimate',
            'ui.bootstrap',
            'TVG.Configuration',
            'TVG.Content',
            'TVG.AppCore',
            'TVG.Layout',
            'TVG.RaceInfo',
            'TVG.Races',
            'TVG.Security',
            'TVG.UserProfile',
            'TVG.Utilities',
            'TVG.BetService',
            'TVG.BetSlipWindow',
            'TVG.Deposit',
            'TVG.Withdraw',
            'TVG.poller',
            'TVG.Features',
            'TVG.TrackSelector',
            'TVG.Templates',
            'TVG.BetslipMain',
            'TVG.FavoriteTracks',
            'TVG.Preferences',
            'TVG.Graph',
            'TVG.GTM'
        ])
            .config([
                '$routeProvider',
                '$locationProvider',
                '$httpProvider',
                '$compileProvider',
                '$uibTooltipProvider',
                'ConfigurationFacProvider',
                'AppRequestInterceptorProvider',
                function ($routeProvider, $locationProvider, $httpProvider, $compileProvider, $uibTooltipProvider, ConfigurationFac, AppRequestInterceptor) {

                    if(envName === 'prod') {
                        $compileProvider.debugInfoEnabled(false);
                    }

                    $uibTooltipProvider.setTriggers({'triggerTooltip': 'triggerTooltip'});

                    AppRequestInterceptor.setMetadata();
                    AppRequestInterceptor.setFeatures();
                    AppRequestInterceptor.setCmsContent();

                    AppRequestInterceptor.setHeadersRequest();
                    AppRequestInterceptor.setInterceptResponse();

                    $locationProvider.html5Mode(true);
                    $routeProvider
                        .when('/betslip/:trackAbbr?/:perfAbbr?/:raceNumber?', {
                            templateUrl: 'js/views/betslip-window.html',
                            title: 'Bet Ticket',
                            hasTopBarNavigation: true
                        });

                }
            ]).run([
                'AppRootFac',
                '$rootScope',
                'CrossWindowMessaging',
                'UserBalanceSvc',
                'ConfigurationFac',
                'GraphClient',
                function (
                        AppRootFac,
                        $rootScope,
                        CrossWindowMessaging,
                        UserBalanceSvc,
                        ConfigurationFac,
                        GraphClient
                    ) {
                    var graphUrl = ConfigurationFac.getServiceApiUrl('graph');

                    // cosmo migration
                    var url = graphUrl
                        .replace("service", "api")
                        .replace("/graph/v2/query", "/cosmo/v1/graphql")
                        .replace("api.us.betfair.com", "tvg-api.us.betfair.com")
                        .replace(
                            "api-qa.us.betfair.com",
                            "tvg-api-qa.us.betfair.com"
                        )
                        .replace(
                            "api-staging.us.betfair.com",
                            "tvg-api-staging.us.betfair.com"
                        )

                    GraphClient.configureGraphClient(url);

                    DepositGTM.default($rootScope);


                    // @HACK - DO NOT REMOVE THIS!
                    // otherwise, UserBalanceSvc won't bind to rootScope's "user" events
                    // and there will be no balance available
                    if (!UserBalanceSvc) {
                        console.warn('UserBalanceSvc must be loaded during app startup!');
                    }

                    if(typeof window !== "undefined" && window.appboy){
                        var environment = {
                            dev: "qa",
                            qa: "qa",
                            staging: "staging",
                            prod: "production"
                        };
                        window.appboy.initialize(ConfigurationFac.getStartupConfig(environment[envName], "braze", "key"),{
                            minimumIntervalBetweenTriggerActionsInSeconds: 5,
                            enableHtmlInAppMessages: true
                        });
                        if($rootScope.user && $rootScope.user.accountNumber){
                            window.appboy.changeUser($rootScope.user.accountNumber);
                        }
                    }

                    AppRootFac.initBetSlip();

                    if ((envName === 'dev' || envName === 'qa') && ($rootScope.activeFeatures && $rootScope.activeFeatures.qaConsumingStagingGraph)) {
                        // when on QA environment, set the graph url to the staging graph so that we have more production-like feeds
                        // this is under toggle so every time anyone wants to consume qa graph we just need to disable the toggle manually
                        graphUrl = ConfigurationFac.getStartupConfig('staging', 'baseUrl', 'service_api') +
                            ConfigurationFac.getStartupConfig('staging', 'service', 'graph');
                    }

                    /* ----- RootScope Functions ----- */
                    AppRootFac.fnGo();
                    AppRootFac.fnGetLocationPath();

                    /* ----- RootScope Listeneners ----- */
                    AppRootFac.onUser();
                    AppRootFac.onLocationChangeStart();
                    AppRootFac.onRouteChangeStart();
                    AppRootFac.onLogin();
                    AppRootFac.onLogout();

                    CrossWindowMessaging.onAccountBalanceUpdate();
                    CrossWindowMessaging.onBetPlaced();
                }]
        );
    }
);

